import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import IDefineHeader from '../header/Header.tsx';
import IDefineSidebar from '../sidebar/Sidebar.tsx';
import styles from './Layout.module.css';
import { useUser } from '../../contexts/UserContext.tsx';

interface IDefineLayoutProps {
  currentModule?: string;
}

const IDefineLayout: React.FC<IDefineLayoutProps> = ({
  currentModule = 'Dashboard'
}) => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  
  // Get user data from context
  const { user } = useUser();
  
  // Use context user data or fallback to defaults
  const userName = user?.userName || 'Guest User';
  // const userRole = user?.role || 'User';

  return (
    <div className={styles.layout}>
      {/* Header */}
      <IDefineHeader 
        currentModule={currentModule}
        userName={userName}
        email={user?.userEmail}
        // userRole={userRole}
      />

      {/* Sidebar */}
      <IDefineSidebar 
        isCollapsed={sidebarCollapsed}
        onToggle={() => setSidebarCollapsed(!sidebarCollapsed)}
        activeItem={currentModule.toLowerCase().replace(' ', '-')}
      />

      {/* Main Content */}
      <main className={`${styles.mainContent} ${sidebarCollapsed ? styles.expanded : ''}`}>
        <div className={styles.contentWrapper}>
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default IDefineLayout;